<div class="mobile calendar-header">
  <button mat-button class="icon-button close-datepicker" matDatepickerCancel>
    <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
  </button>
  <div class="heading-3 bold">{{ 'general.api_datepicker_header' | translate }}</div>
</div>
<div class="presets" *ngIf="!noPresets">
  <mat-button-toggle-group class="content-switcher small">
    <mat-button-toggle [value]="todayPreset" [checked]="getPanelClass === todayPreset" (click)="selectDate(todayPreset)">
      {{ 'general.api_datepicker_preset_' + todayPreset | translate }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div class="date">
  <button mat-button class="prev input-button icon-button" [ngClass]="{'small': !utilService.isMobile}" (click)="previousClicked()">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
  </button>
  <div class="header-label">
    <button mat-button color="primary" class="month input-button" [ngClass]="{'small': !utilService.isMobile}"
            (click)="switchCalendarView('year')">{{periodMonthLabel()}}</button>
    <button mat-button color="primary" class="year input-button" [ngClass]="{'small': !utilService.isMobile}"
            (click)="switchCalendarView('multi-year')">{{periodYearLabel()}}</button>
  </div>
  <button mat-button class="next input-button icon-button" [ngClass]="{'small': !utilService.isMobile}" (click)="nextClicked()">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
  </button>
</div>
